<template>
  <v-container fluid id="FirstPage">
    <v-row align="end" no-gutters style="height: 100%;margin-bottom: 0px;padding-bottom: 0px;">
      <v-col cols="12" style="text-align: center  ;direction: rtl;">
        <v-btn @click="$router.push('/comment')" class="my-font"> ارسال پیام </v-btn>
        <v-btn @click="$router.push('/search')" class="my-font"> پیگیری </v-btn>
      </v-col>
      <!-- <v-col cols="12" style="text-align: center">
        <a href="/comment" class="my-font"> ارسال پیام </a>
        <a href="/search" class="my-font"> پیگیری </a>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'FirstPage',
  props: {
    msg: String
  },
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@media (max-width:960px) {
  #FirstPage {
    background-image: url("./../assets/img/page-mobile.jpg");
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: contain;
    background-position: center;
    height: 100vh;
    overflow: hidden;
  }
}

@media (min-width:960px) {
  #FirstPage {
    background-image: url("./../assets/img/page-full.jpg");
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: contain, cover;
    background-position: center;
    height: 100vh;
    overflow: hidden;
  }
}

.my-font {

  padding: 5px 10px;
  margin: 0 1px;
  border-radius: 5px;
  color: #fff !important;
  background: #0b3f48 !important;
  text-decoration: none;
  font-variation-settings: "wght" 400;
  letter-spacing: 0 !important;
  font-size:  1rem;
}
</style>
